export default {
  headerContent: {
    title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Otomobil sigortası, bir kaza durumunda sizi maddi kayıplara karşı koruyan ve sigorta şirketi arasında yapılan bir sözleşmedir. Bir prim ödemeniz karşılığında, sigorta şirketi karşı sürücüye verdiğiniz zararlarınızı poliçenizde belirtildiği şekilde ödemeyi kabul eder. Yasal olarak zorunlu olan trafik sigortasını Türkiye Sigorta güvencesi altına alabilirsiniz.',
        'Yasal olarak zorunlu olan trafik sigortasını Türkiye Sigorta kapsamında güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Trafik Sigortası trafikte yer alan tüm motorlu araçların yaptırması zorunlu olan sigorta ürünüdür.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu trafik sigortası ile karayolunda oluşabilecek kaza sonucunda karşı tarafın veya 3. Şahısların uğrayacağı zarardan doğan hukuki sorumlulukları güvence altına alınır. Bu kapsamda meydana gelen zarar ve hasarlar trafik sigortası limitleri doğrultusunda karşılanır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası ana teminatları Hazine Müsteşarlığı tarafından belirlenmektedir.',
          subList: [
            'Maddi Zarar Teminatı',
            'Sağlık Giderleri Teminatı',
            'Sürekli Sakatlık ve Vefat Teminatıdır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'İşletilme haline olmayan araçların neden olacağı hasarlar',
            'Sigortalının kusur oranına denk gelmeyen tazminat talepleri',
            'Sigortalının yükümlülükleri kapsamında olmayan tazminat talepleri',
            'Kazaya karışan araçların aynı şahıs veya kuruma ait olması sonucu olan hasarlar',
            'Manevi tazminat talepleri',
            'Çalınmış veya gasp edilmiş araçların oluşturacağı hasarlar',
            'Kâr kaybı talepleri',
            'Değer kaybı talepleri'
          ]
        },
        {
          paragraph:
            'Zorunlu trafik sigortası kapsamı dışında tutuşmuştur.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Zorunlu Trafik Sigortası Geçerlilik Süresi Ne Kadardır?',
      content: [
        {
          paragraph:
            'Trafik sigortası geçerlilik süresi poliçede yazılı olan tarihidir. Trafik sigortası poliçesinde yer alan başlangıç tarihinden itibaren geçerlilik süresi 1 yıldır. Bu süre son bulmadan poliçenizi yeniletmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Trafik Sigortası Coğrafi Sınırı Nedir?',
      content: [
        {
          paragraph:
            'Trafik sigortası Türkiye sınırları içerisinde geçerlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Hasar Anında İstenen Belgeler Nelerdir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Kaza tespit tutanağı',
            'Araç ruhsatı ve araç sürücüsünün ehliyet fotokopisi',
            'Hasar dosyası hakkında bilgilendirilecek bireyin telefon numarası',
            'Kaza ve kaza yeri fotoğrafları istenmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigortadan Trafik Sigortasını Taksitle Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Trafik sigortanızı kredi kartınızla 12 taksite kadar vadeye bölebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
